import { isCancelledRequest } from 'shared/channels/cancellation';
import { isChannelRequestTimeout } from 'shared/channels/errors';
import { logError } from './logError';

/**
 * Logs a failed request to the service worker. A timeout is skipped: the
 * channel layer already reported it once, with diagnostics. So is a request
 * that was cancelled: it did not fail.
 */
export function logChannelRequestFailure(
  message: string,
  error: unknown,
  context: Record<string, unknown> = {}
): void {
  if (!isChannelRequestTimeout(error) && !isCancelledRequest(error)) {
    logError(message, { error, ...context });
  }
}
